import { get } from 'lodash-es';
import * as React from 'react';
import { UseFormGetValues } from 'react-hook-form';

import { ids } from './constants';

interface RadioButtonOwnProps {
  label: string;
  fieldName: string;
  value: string;
  getValues: UseFormGetValues<any>;
  onChange: (e: any) => void;
  onBlur?: (e: any) => void;
}

type RadioButtonProps = RadioButtonOwnProps;

const RadioButton: React.FC<RadioButtonProps> = (props) => {
  const { label, value, fieldName, getValues, onChange, onBlur } = props;
  return (
    <label
      className="radio p-y-0 size-md"
      id={`${get(ids, fieldName)}_${value}_label`}
    >
      <input
        type="radio"
        id={`${get(ids, fieldName)}_${value}`}
        name={fieldName}
        defaultChecked={getValues(fieldName) === value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      <span className="radio-indicator" />
      <span>{label}</span>
    </label>
  );
};

RadioButton.displayName = 'RadioButton';
export default RadioButton;
